import govLogo from '@/assets/common/gov.png';
export default {
  data: function data() {
    return {
      govLogo: govLogo,
      labelList: [{
        name: '云南省人民政府门户网',
        url: 'https://www.yn.gov.cn/'
      }, {
        name: '云南省中小企业公共服务平台',
        url: 'https://www.ynsmes.cn/website/Provincial/index.aspx'
      }, {
        name: '大理白族自治州人民政府门户网',
        url: 'https://www.dali.gov.cn/'
      }, {
        name: '祥云县人民政府网',
        url: 'http://www.xiangyun.gov.cn/'
      }],
      list: [{
        title: '服务热线',
        content: [{
          name: '800-23889867',
          url: ''
        }]
      }, {
        title: '帮助指南',
        content: [{
          name: '操作指南',
          url: '/guide'
        }]
      }, {
        title: '服务备案号',
        content: [{
          name: '滇ICP备2025051454号-1',
          url: 'https://beian.miit.gov.cn/#/Integrated/index'
        }]
      }]
    };
  },
  methods: {
    open: function open(item) {
      if (item.url) {
        window.open(item.url, '_blank');
      }
    }
  }
};